module.exports = __webpack_public_path__ + "media/images/car-f153bdf74a8880402398a51d4a3cba4b.svg";